// import axios from 'axios';
// import { useEffect, useRef, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';

// const ViewTicketDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(true);
//     const [chats, setChats] = useState([]);
//     const [canSend, setCanSend] = useState(true);
//     const [newMessage, setNewMessage] = useState('');
//     const [warning, setWarning] = useState('');

//     const chatContainerRef = useRef(null);

//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     const scrollToBottom = () => {
//         if (chatContainerRef.current) {
//             chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//     };

//     const fetchTicketData = async () => {
//         const token = localStorage.getItem('accessToken');

//         try {
//             const formData = new FormData();
//             formData.append('ticket_id', id);
//             const res = await axios.post(
//                 'https://app.homegurus.in/api/user-all-tickets',
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                     },
//                 }
//             );

//             console.log(res.data);

//             setChats(res.data.ticket)
//         } catch (error) {
//             console.error('Error fetching ticket data', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchTicketData();
//     }, []);

//     useEffect(() => {
//         scrollToBottom();
//     }, [chats]);

//     const handleSendMessage = () => {
//         if (newMessage.trim() === '' || !canSend) return;

//         const newChat = {
//             message: newMessage.trim(),
//             is_user: true,
//             created_at: new Date().toISOString(),
//         };

//         setChats((prevChats) => [...prevChats, newChat]);
//         setNewMessage('');
//         setCanSend(false);

//         setTimeout(() => {
//             const reply = {
//                 message: "Thanks, we'll look into it!",
//                 is_user: false,
//                 created_at: new Date().toISOString(),
//             };

//             setChats((prevChats) => [...prevChats, reply]);
//             setCanSend(true);
//         }, 1000);
//     };

//     const handleKeyDown = (e) => {
//         if (e.key === 'Enter') handleSendMessage();
//     };

//     return (
//         <div className="max-w-2xl mx-auto p-6 border shadow rounded">
//             <div className="flex justify-between items-center mb-4 border-b pb-3">
//                 <div>
//                     <h1 className="text-lg font-semibold">Ticket ID: {id}</h1>
//                     <p className="text-sm text-gray-500">Chat with Support</p>
//                 </div>
//                 <button
//                     onClick={handleBackClick}
//                     className="px-4 py-1 rounded-md text-white bg-black hover:bg-gray-800"
//                 >
//                     Back
//                 </button>
//             </div>

//             {loading ? (
//                 <div className="spinner"></div>
//             ) : (
//                 <>
//                     <div
//                         ref={chatContainerRef}
//                         className="space-y-3 max-h-[400px] overflow-y-auto pr-2 mb-4"
//                     >
//                         {chats?.map((chat, index) => (
//                             <div
//                                 key={index}
//                                 className={`p-3 rounded-lg text-sm max-w-[70%] ${chat.is_user ? 'bg-blue-100 ml-auto text-right' : 'bg-gray-100 mr-auto text-left'
//                                     }`}
//                             >
//                                 <p className="font-medium text-xs text-gray-700 mb-1">{chat.sender_name}</p>
//                                 <p>{chat.message}</p>
//                                 <span className="block text-[10px] text-gray-500 mt-1">
//                                     {new Date(chat.created_at).toLocaleString()}
//                                 </span>
//                             </div>
//                         ))}
//                     </div>
//                     <div className="flex flex-col w-full gap-1">
//                         <div className="flex items-center gap-2">
//                             <input
//                                 type="text"
//                                 className="flex-grow border rounded px-3 py-2 text-sm"
//                                 placeholder="Type your message..."
//                                 value={newMessage}
//                                 onChange={(e) => {
//                                     if (canSend) {
//                                         setNewMessage(e.target.value);
//                                         setWarning('');
//                                     } else {
//                                         setWarning('Please wait for a reply before sending another message.');
//                                     }
//                                 }}
//                                 onFocus={() => {
//                                     if (!canSend) {
//                                         setWarning('Please wait for a reply before sending another message.');
//                                     }
//                                 }}
//                                 disabled={!canSend}
//                             />
//                             <button
//                                 onClick={handleSendMessage}
//                                 className="btn-primary-sm"
//                                 disabled={!canSend}
//                             >
//                                 Send
//                             </button>
//                         </div>
//                         {warning && <p className="text-xs text-red-500 mt-1">{warning}</p>}
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default ViewTicketDetails;


import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ViewTicketDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [chats, setChats] = useState([]);
    const [canSend, setCanSend] = useState(true);
    const [newMessage, setNewMessage] = useState('');
    const [warning, setWarning] = useState('');

    const chatContainerRef = useRef(null);

    const handleBackClick = () => {
        navigate(-1);
    };

    const scrollToBottom = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    const fetchTicketData = async () => {
        const token = localStorage.getItem('accessToken');

        try {
            const formData = new FormData();
            formData.append('ticket_id', id);

            const res = await axios.post(
                'https://app.homegurus.in/api/user-all-tickets',
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            const allTickets = res.data.tickets || [];

            const matchedTicket = allTickets.find(ticket => ticket.id.toString() === id.toString());

            if (!matchedTicket) {
                console.error("Ticket not found.");
                return;
            }

            const mergedChats = [
                ...matchedTicket.user_messages.map(msg => ({
                    message: msg.message,
                    is_user: true,
                    created_at: msg.created_at,
                    sender_name: msg.user?.name || "You"
                })),
                ...matchedTicket.admin_replies.map(reply => ({
                    message: reply.reply,
                    is_user: false,
                    created_at: reply.created_at,
                    sender_name: "Home Gurus Support"
                }))
            ].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            console.log(mergedChats);

            setChats(mergedChats);

            const lastMessage = mergedChats[mergedChats.length - 1];
            setCanSend(!lastMessage || !lastMessage.is_user);
        } catch (error) {
            console.error('Error fetching ticket data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            fetchTicketData();
        }, 5000); // 15 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [chats]);

    const handleSendMessage = async () => {
        if (newMessage.trim() === '' || !canSend) return;

        const token = localStorage.getItem('accessToken');

        try {
            setCanSend(false); // block sending again

            await axios.post(
                `https://app.homegurus.in/api/tickets/${id}/message`,
                { message: newMessage.trim() },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            const newChat = {
                message: newMessage.trim(),
                is_user: true,
                created_at: new Date().toISOString(),
                sender_name: 'You',
            };

            setChats((prevChats) => [...prevChats, newChat]);
            setNewMessage('');
            setWarning('');
            // Don't set canSend to true until admin replies
        } catch (error) {
            console.error('Error sending message:', error);
            setCanSend(true); // let user retry if sending fails
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSendMessage();
    };

    return (
        <div className=" mx-auto p-6 border shadow rounded">
            <div className="flex justify-between items-center mb-4 border-b pb-3">
                <div>
                    <h1 className="text-lg font-semibold">Ticket ID: {id}</h1>
                    <p className="text-sm text-gray-500">Chat with Support</p>
                </div>
                <button
                    onClick={handleBackClick}
                    className="px-4 py-1 rounded-md text-white bg-black hover:bg-gray-800"
                >
                    Back
                </button>
            </div>

            {loading ? (
                <div className="spinner"></div>
            ) : (
                <>
                    <div
                        ref={chatContainerRef}
                        className="space-y-3 max-h-[400px] overflow-y-auto pr-2 mb-4"
                    >
                        {chats?.map((chat, index) => (
                            <div
                                key={index}
                                className={`p-3 rounded-lg text-sm max-w-[70%] ${chat.is_user ? 'bg-blue-100 ml-auto text-right' : 'bg-gray-100 mr-auto text-left'
                                    }`}
                            >
                                <p className="font-medium text-xs text-gray-700 mb-1">{chat.sender_name}</p>
                                {/* <p className="font-medium text-xs text-gray-700 mb-1">{chat.sender_name}</p> */}
                                <p>{chat.message}</p>
                                <span className="block text-[10px] text-gray-500 mt-1">
                                    {new Date(chat.created_at).toLocaleString()}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="flex flex-col w-full gap-1">
                        <div className="flex items-center gap-2">
                            <input
                                type="text"
                                className="flex-grow border rounded px-3 py-2 text-sm"
                                placeholder="Type your message..."
                                value={newMessage}
                                onChange={(e) => {
                                    if (canSend) {
                                        setNewMessage(e.target.value);
                                        setWarning('');
                                    } else if (!loading) {
                                        setWarning('Please wait for admin to reply before sending another message.');
                                    }
                                }}

                                onFocus={() => {
                                    if (!canSend && !loading) {
                                        setWarning('Please wait for a reply before sending another message.');
                                    }
                                }}

                                disabled={!canSend}
                            />
                            <button
                                onClick={handleSendMessage}
                                className="btn-primary-sm"
                                disabled={!canSend}
                            >
                                Send
                            </button>
                        </div>
                        {warning && <p className="text-xs text-red-500 mt-1">{warning}</p>}
                    </div>
                </>
            )}
        </div>
    );
};

export default ViewTicketDetails;
